import React from 'react';
import { IconButton, Select, MenuItem, Typography, Box, Divider } from '@mui/material';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './CustomPagination.scss';

const CustomPagination = ({
  totalNumberOfPages,
  currentPageNumber,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions,
  labelText = 'Rows per page:'
}) => {


  const DropdownIcon = ({ open, ...props }) => {
	return (
		<Box style={{ paddingRight: '16px' }}>
		{open ? <KeyboardArrowUpIcon {...props} sx={{fill: '#111111'}}/> : <KeyboardArrowDownIcon {...props} sx={{fill: '#111111'}}/>}
		</Box>
	);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, currentPageNumber - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, currentPageNumber + 1);
  };

  const handlePageNumberChange = (event) => {
    onPageChange(event, parseInt(event.target.value, 10));
  };

  const handleRowsPerPageChange = (event) => {
    onRowsPerPageChange(event);
  };

  //console.log(totalNumberOfPages, ' :total number of pages');

  return (
	<div className='custom-pagination'>
		<Box display='flex' justifyContent='flex-end' alignItems='center' padding='16px'>
		<Typography>
			{labelText}
		</Typography>
		<Select
			value={rowsPerPage}
			onChange={handleRowsPerPageChange}
			IconComponent={DropdownIcon}
			className='dropdown1'
		>
			{rowsPerPageOptions.map(rows => (
			<MenuItem key={rows} value={rows}>{rows}</MenuItem>
			))}
		</Select>

		<Divider orientation='vertical' flexItem className='divider-line' />

		<IconButton
			onClick={handleBackButtonClick}
			disabled={currentPageNumber === 0}
			aria-label='previous currentPageNumber'
			style={{ color: currentPageNumber === 0 ? '' : '#00563C', borderRadius: 0, paddingLeft: '0px' }}
		>
			<WestIcon />
			<Typography component='span' className='prev-button'>Prev</Typography>
		</IconButton>

		<Select
			value={currentPageNumber}
			onChange={handlePageNumberChange}
			className='dropdown2'
			IconComponent={DropdownIcon}
		>
			{totalNumberOfPages > 0 ? (
				Array.from({ length: totalNumberOfPages }, (_, index) => (
				<MenuItem key={index} value={index}>{index + 1}</MenuItem>
				))
			) : (
				// Provide a default option for 0 pages
				<MenuItem value={0}>1</MenuItem>
			)}
		</Select>

		<Typography className='margin08'>
			of {totalNumberOfPages > 0 ? totalNumberOfPages : 1}
		</Typography>

		<IconButton
			onClick={handleNextButtonClick}
			disabled={currentPageNumber >= totalNumberOfPages - 1}
			aria-label='next currentPageNumber'
			style={{ color: currentPageNumber >= totalNumberOfPages - 1 ? '' : '#00563C', borderRadius: 0 }}
		>
			<Typography component='span' className='next-button'>Next</Typography>
			<EastIcon />
		</IconButton>
		</Box>
	</div>
  );
};

export default CustomPagination;
